// v4.2.0 — ContinueReadingStrip (universel).
// Affiche les CONTENT achetés et non terminés avec vignette couverture + CTA "Reprendre".

import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export default function ContinueReadingStrip({ onResume }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    async function load() {
      const token = localStorage.getItem("civ_user_token");
      if (!token) return;
      const authHeaders = { Authorization: `Bearer ${token}` };
      try {
        const re = await axios.get(`${BACKEND_URL}/api/v3/content/entitlements`, { headers: authHeaders });
        const items = re.data?.entitlements || [];
        const withProgress = await Promise.all(
          items.map(async (ent) => {
            try {
              const rp = await axios.get(`${BACKEND_URL}/api/v3/content/${ent.resource_id}/progress`, { headers: authHeaders });
              return { ent, state: rp.data?.state };
            } catch (_) {
              return { ent, state: null };
            }
          }),
        );
        const inProgress = withProgress
          .filter((row) => row.state && row.state.current_page > 0 && (row.state.progress_pct || 0) < 100)
          .sort((a, b) => (b.state.last_read_at || "").localeCompare(a.state.last_read_at || ""));
        setRows(inProgress);
      } catch (_) {}
    }
    load();
  }, []);

  if (rows.length === 0) return null;

  return (
    <div data-testid="continue-reading-strip" className="continue-reading-strip">
      <div className="text-xs uppercase tracking-[0.25em] text-amber-300/90 font-semibold mb-3 px-1">
        📖 Continuer mes lectures
      </div>
      <div className="flex flex-col gap-2.5">
        {rows.map(({ ent, state }) => {
          const c = ent.content;
          if (!c) return null;
          return (
            <button
              key={ent.resource_id}
              onClick={() => onResume && onResume(ent.resource_id, state)}
              data-testid={`continue-reading-${ent.resource_id}`}
              className="flex items-center gap-3 p-2.5 rounded-2xl border border-white/10 bg-white/[0.04] hover:bg-white/[0.08] hover:border-amber-400/30 text-left transition-all"
            >
              <div className="w-11 h-[58px] rounded-md overflow-hidden bg-white shrink-0 shadow">
                {c.cover_url ? (
                  <img src={c.cover_url} alt={c.title} className="w-full h-full object-cover object-top" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-xl">📰</div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-white line-clamp-1">{c.title}</div>
                <div className="text-xs text-white/45 mt-0.5">
                  Page {state.current_page} / {state.total_pages} · {state.progress_pct}%
                </div>
                <div className="mt-1.5 h-1 rounded-full bg-white/10 overflow-hidden">
                  <div
                    className="h-full bg-gradient-to-r from-amber-500 to-amber-300"
                    style={{ width: `${state.progress_pct}%` }}
                  />
                </div>
              </div>
              <div className="text-amber-300 text-sm font-medium whitespace-nowrap">Reprendre →</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
